var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import './FilterPanel.scss';
import { UuiFlexlayout } from '@aonunited/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faFileExcel, faSearch } from '@fortawesome/free-solid-svg-icons';
import { AonButton } from '../../../../components/core/AonButton';
import { BUTTON_VARIANT } from '../../../../components/core/AonButton/consts';
import { AdvanceSearchDailog } from '../../../Dailog/AdvanceSearchDialog';
import { AddNewMarketsDailog } from '../../../Dailog/AddNewMarketDialog';
import { useClientPageStore, useErrorStore } from '../../../../store';
import { getMarketDataReport } from '../../../../api/marketData/ExportMarketData';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '../../../../components/ToolTip/ToolTip';
var MarketListFilter = function (props) {
    var _a = useState(""), searchValue = _a[0], setSearchValue = _a[1];
    var _b = useState(false), showAdvanceModal = _b[0], setShowAdvanceModal = _b[1];
    var _c = useState(false), showAddNewMarketModal = _c[0], setShowAddNewMarketModal = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var clientStore = useClientPageStore();
    var navigation = useNavigate();
    var errorStore = useErrorStore();
    var handleClear = function () {
        setSearchValue("");
        props.onClickClear();
    };
    useEffect(function () {
        var inputRef = document.getElementById("__marketListSearchInput__");
        if (inputRef) {
            inputRef.addEventListener("keydown", function (Event) {
                if (Event.key === "Enter") {
                    setSearchValue((Event === null || Event === void 0 ? void 0 : Event.target).value);
                    Event === null || Event === void 0 ? void 0 : Event.preventDefault();
                }
            });
        }
    }, []);
    var openAdvanceModal = function () {
        setShowAdvanceModal(true);
    };
    var openAddNewMarketModal = function () {
        setShowAddNewMarketModal(true);
    };
    var exportDataToExelFile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var allMarketId, response, binaryString, byteArray, i, blob, link, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    allMarketId = (_b = (_a = props.gridData) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.marketId; })) === null || _b === void 0 ? void 0 : _b.join(",");
                    if (!allMarketId) {
                        return [2 /*return*/];
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    setLoading(true);
                    return [4 /*yield*/, getMarketDataReport({ marketIds: allMarketId })];
                case 2:
                    response = _c.sent();
                    binaryString = atob(response.data.content);
                    byteArray = new Uint8Array(binaryString.length);
                    for (i = 0; i < binaryString.length; i++) {
                        byteArray[i] = binaryString.charCodeAt(i);
                    }
                    blob = new Blob([byteArray], { type: response.data.mimeType });
                    link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = response.data.name;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _c.sent();
                    console.log("error in export market Data");
                    errorStore.showError({ message: "Error", code: "500" });
                    navigation('/error');
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var InputListner = function (Event) {
            if (Event.key === "Enter") {
                props.onClickSearch(Event.target.value);
                Event === null || Event === void 0 ? void 0 : Event.preventDefault();
            }
        };
        var inputRef = document.getElementById("__marketNewsSearchInput__");
        if (inputRef) {
            inputRef.addEventListener("keydown", InputListner);
        }
        return function () {
            inputRef.removeEventListener("keydown", InputListner);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(UuiFlexlayout, { direction: 'row', className: 'client-list-wrapper' },
            React.createElement("div", { className: "search-pannel" },
                React.createElement(UuiFlexlayout, { direction: 'row', gap: 'xs', alignItems: 'center' },
                    React.createElement("div", { style: { marginRight: "5px", color: 'grey' } },
                        React.createElement("span", null, "Search:")),
                    React.createElement("div", { className: 'text-input-field' },
                        React.createElement("input", { className: 'text-input', onChange: function (event) { return setSearchValue(event.target.value); }, value: searchValue, type: "text", name: "", id: "__marketNewsSearchInput__", placeholder: 'Name, Aon ID, AM Best Id, S&P Id...' }),
                        searchValue && React.createElement(FontAwesomeIcon, { onClick: handleClear, className: 'text-icon', icon: faClose }),
                        React.createElement(FontAwesomeIcon, { onClick: function () { return props.onClickSearch(searchValue); }, className: 'text-icon', icon: faSearch })))),
            React.createElement(UuiFlexlayout, { direction: 'row', className: 'action-panel' },
                React.createElement("div", { style: { marginInline: "10px", paddingTop: "10px" }, className: 'button-decoration', onClick: function () { return openAdvanceModal(); } }, "Advanced Search"),
                React.createElement(AonButton, { style: { marginInline: "5px" }, disabled: !props.addMarket, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return props.addMarket ? props.addMarket() : undefined; } }, "Add New Market(s)"),
                React.createElement(AonButton, { style: { marginInline: "5px" }, disabled: !props.removeMarket, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return props.removeMarket ? props.removeMarket() : undefined; } }, "Remove Market(s)"),
                React.createElement(AonButton, { disabled: !clientStore.isUserHaveFullAccess, style: { marginInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () { return openAddNewMarketModal(); } }, "Add Market Not Found on Guide"),
                loading ? React.createElement("div", null, "Loading...") : React.createElement("div", null,
                    React.createElement(Tooltip, { content: "Export to Excel", direction: "bottom" },
                        React.createElement("div", { onClick: exportDataToExelFile },
                            React.createElement(FontAwesomeIcon, { style: { marginInline: "30px", paddingTop: "10px", fontSize: "28px", color: "green", cursor: "pointer" }, icon: faFileExcel })))))),
        showAdvanceModal && React.createElement(AdvanceSearchDailog, { handleAdvanceSearch: props.handleAdvanceSearch, showDailog: showAdvanceModal, onClickClose: function () { return setShowAdvanceModal(false); }, clientGuid: props.clientGuid }),
        showAddNewMarketModal && React.createElement(AddNewMarketsDailog, { showDailog: showAddNewMarketModal, onClickClose: function () { return setShowAddNewMarketModal(false); } })));
};
export { MarketListFilter };
